"use client";
import i, { useState as c, useEffect as E } from "react";
import "./index.es73.js";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import "./index.es79.js";
import "./index.es80.js";
import d from "./index.es81.js";
import "./index.es83.js";
import "./index.es84.js";
import "./index.es85.js";
import "./index.es86.js";
import "./index.es87.js";
import "./index.es88.js";
import "./index.es89.js";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es176.js";
import "./index.es178.js";
import "./index.es179.js";
import "./index.es180.js";
import "./index.es181.js";
import "./index.es182.js";
import "./index.es183.js";
import b from "./index.es365.js";
import f from "styled-components";
const g = f.div`
  .bl-accordion:not(.bl-accordion--is-closed) .bl-accordion__content {
    overflow: visible;
    .bl-info-box: overflow: visible;
  }
`, y = f.div`
  text-align: right;
  button {
    display: inline-block;
    border: none;
  }
`, tt = ({
  content: t,
  settings: p,
  parentId: n
}) => {
  const u = t.description && t.description.length > 0 && t.explanation && t.explanation.length > 0 && !0, [r, a] = c(
    p.isDescriptionOpen || !1
  ), [l, m] = c(
    p.isExplanationOpen || !1
  );
  E(() => {
    const { isDescriptionOpen: e, isExplanationOpen: o } = p;
    a(
      typeof e == "boolean" ? e : r
    ), m(
      typeof o == "boolean" ? o : l
    );
  }, [p]);
  const x = r && l ? "Lukk Alle" : "Åpne alle", k = (e) => {
    e.preventDefault(), r && l ? (a(!1), m(!1)) : (a(!0), m(!0));
  };
  return /* @__PURE__ */ i.createElement(g, { className: "bl-container bl-container--small bl-m-b-4" }, u && /* @__PURE__ */ i.createElement(y, null, /* @__PURE__ */ i.createElement(
    "button",
    {
      className: "bl-link bl-m-y-2 bl-size-5",
      onClick: k
    },
    x
  )), t?.explanation && t?.explanation.length > 0 && /* @__PURE__ */ i.createElement(
    b,
    {
      contentId: `explanation-${n}`,
      isOpen: l,
      header: "Dette viser grafen",
      onClick: () => m(!l)
    },
    t.explanation.map((e, o) => {
      const s = `${n}-explanation-${o}`;
      return /* @__PURE__ */ i.createElement(d, { key: s, keyContext: s, ...e });
    })
  ), t?.description && t.description.length > 0 && /* @__PURE__ */ i.createElement(
    b,
    {
      contentId: `description-${n}`,
      isOpen: r,
      header: "Om datagrunnlaget",
      onClick: () => a(!r)
    },
    t.description.map((e, o) => /* @__PURE__ */ i.createElement(
      d,
      {
        key: `${n}-description-${o}`,
        keyContext: `${n}-description-${o}`,
        ...e
      }
    ))
  ));
};
export {
  tt as default
};
//# sourceMappingURL=index.es278.js.map
